import { render, staticRenderFns } from "./OfficesTable.vue?vue&type=template&id=6b4a0cd0&scoped=true"
import script from "./OfficesTable.vue?vue&type=script&lang=js"
export * from "./OfficesTable.vue?vue&type=script&lang=js"
import style0 from "./OfficesTable.vue?vue&type=style&index=0&id=6b4a0cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a0cd0",
  null
  
)

export default component.exports